import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=f5648bc8&scoped=true&"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5648bc8",
  null
  
)

export default component.exports